import React from 'react'
import { string } from 'prop-types'

const ContentWrapper = ({ content }) => {
  const createResponsiveTable = str => str.replace(
      /<table/g, '<div class="table-responsive"><table'
    ).replace(
      /<\/table>/g, '</table></div>'
    )

  return (
    <>
      <div className="cmps-content-wrapper" dangerouslySetInnerHTML={{ __html: createResponsiveTable(content) }} />
      <style jsx global>
        {`
          .cmps-content-wrapper {
            .table-responsive {
              &::-webkit-scrollbar-track {
                border-radius: 10px;
                width: 5px;
                background-color: #bed2e8;
              }
              &::-webkit-scrollbar {
                border-radius: 10px;
                width: 5px;
                background-color: #bed2e8;
              }
              &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                width: 5px;
                background-color: #0fc3c4;
              }
            }
            p, ul>li {
              font-size: 16px !important;
              line-height: 2 !important;
              margin-bottom: 1.5rem !important;
            }
            table {
              table-layout: fixed;
              min-width: 900px;
              border-collapse: collapse;
              border-radius: 8px;
              overflow: hidden;
              background-color: #fff;
              tbody {
                tr:nth-of-type(odd) {
                  background-color: inherit;
                }
                tr:nth-of-type(even) {
                  background-color: #f6f7fa;
                }
              }
              th, td {
                padding: 16px;
                font-size: 16px !important;
                border: solid 1px #ddd;
                p:nth-last-child(1) {
                  margin-bottom: unset !important;
                }
              }
              th {
                background-color: #0fc3c4;
                color: #fff;
                font-weight: 700 !important;
                p, span {
                  font-weight: 700 !important;
                }
              }
              td {
                background-color: inherit;
                padding-left: 2em;
                padding-right: 2em;
                ul {
                  padding-left: 1em;
                }
              }
              th[rowspan] {
                vertical-align: top;
              }
            }
          }
        `}
      </style>
    </>
  )
}

ContentWrapper.propTypes = {
  content: string,
}

export default ContentWrapper
